import QuickBooksMappingPage from '~pages/Settings/Integrations/QuickBooksMapping/QuickBooksMappingPage';
import { RutterManagementAccess } from '~pages/Settings/Integrations/RutterManagement';

const RutterQuickBooks = () => {
  return <RutterManagementAccess component={QuickBooksMappingPage} />;
};

export default RutterQuickBooks;
